'use strict';

namespace core {

    class BreakdownTable {

        total: number;
        tax: number;
        package: number;

        constructor(private modalService:any, private $filter:any){

            this.tax = this.$filter('customCurrency')(modalService.get('tax'));
            //this.currency = this.$filter('customCurrency')(modalService.get('currency'));
            this.total = this.$filter('customCurrency')(modalService.get('total'));
            this.package = this.$filter('customCurrency')(modalService.get('total') + modalService.get('tax'));

        }

    }

    angular
    .module('core')
    .directive('breakdownTable', () => {
        return {
            restrict: 'E',
            templateUrl: 'partials/home/directivetemplate?type=BreakdownTable',
            controllerAs: 'bt',
            controller: BreakdownTable
        };
    });

}
